import { Box, formatPhoneNumber, Grid, Stack, Typography, useElementBreakpoints } from "@compass/core";
import { BulkSelected, Select, StudentCustomIdsPaster } from "components";
import {
  BulkSelectedItemErrors,
  PersonDto,
  Student,
  StudentBulkCreateServicesResource,
  StudentGroup,
  TextingOptInStudentDto,
} from "generated/openApi";
import ApiService from "services/apiService";

export const SelectedPersons = (props: {
  optInNumbers: TextingOptInStudentDto[];
  persons: Map<number, PersonDto>;
  setPersons: (value: Map<number, PersonDto>) => void;
  errors: BulkSelectedItemErrors[];
  setErrors: (value: BulkSelectedItemErrors[]) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints, fullFieldBreakpoints } = useElementBreakpoints();

  const getItemLabel = (person: PersonDto) => (
    <Stack>
      {person.cellPhone && (
        <>
          <Typography>
            {person.lastName}, {person.firstName} ({person.identification})
          </Typography>
          <Typography variant="caption" lineHeight="100%">
            {formatPhoneNumber(person.cellPhone)}
          </Typography>
          {props.optInNumbers.some(n => n.customId1 == person.identification) && (
            <Typography variant="caption" lineHeight="100%" color="green">
              Opted-In
            </Typography>
          )}
          {!props.optInNumbers.some(n => n.customId1 == person.identification) && (
            <Typography variant="caption" lineHeight="100%" color="orange">
              Not Opted-In
            </Typography>
          )}
        </>
      )}
      {!person.cellPhone && (
        <>
          <Typography color="error">
            {person.lastName}, {person.firstName} ({person.identification})
          </Typography>
          <Typography variant="caption" lineHeight="100%" color="error">
            No valid cell phone number.
          </Typography>
        </>
      )}
    </Stack>
  );

  return (
    <Box ref={breakpointsRef}>
      <BulkSelected
        label="Person"
        items={props.persons || []}
        setItems={(value) => props.setPersons(value)}
        getItemLabel={getItemLabel}
        errors={props.errors}
        setErrors={props.setErrors}
      // quickAdd={
      //   <Grid container spacing="sm">
      //     <Grid item xs={smallFieldBreakpoints}>
      //       <Select
      //         label="Add by Name"
      //         value={undefined as unknown as Student}
      //         onChange={(e, value) => {
      //           const newStudents = new Map(props.students);
      //           newStudents.set(value.id, value);
      //           props.setStudents(newStudents);
      //         }}
      //         fetchFunction={(searchString) => ApiService.search.students(searchString)}
      //         isOptionEqualToValue={(option, value) => option.id === value.id}
      //         getOptionDisabled={(option) => props.students.has(option.id)}
      //         renderOption={(props, option) => (
      //           <Box component="li" {...props}>
      //             {getItemLabel(option)}
      //           </Box>
      //         )}
      //         getOptionLabel={() => ""}
      //       />
      //     </Grid>
      //   </Grid>
      // }
      />
    </Box>
  );
};
